import React, { ReactElement } from "react";
import { GetServerSideProps } from "next";
import { getPageProps } from "@services/initial-calls";
import GoAutoWarrantyWrapper from "@components/layouts/goAutoWarrantyWrapper";
import ContactTop from "@components/antiviruschoice/contactTop";
import FormSection from "@components/antiviruschoice/formSection";

export default function GoAutoWarrantyHome(): ReactElement {
    return (
        <GoAutoWarrantyWrapper>
            <div className="bg-white">
                <ContactTop iconsFillColor="#F57F26" />
            </div>
            <FormSection iconsFillColor="#00445F" />
        </GoAutoWarrantyWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", { pageTitle: "Contact Us" });
};
